import styled, { keyframes } from 'styled-components'

const rotation = keyframes`
  from {
      transform: rotate(0);
  }

  to {
    transform: rotate(-45deg);
  }
`

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: #f8f9f9;

  margin-top: -40px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) and (orientation: portrait) {
    padding: 20px;
  }
`

export const Signable = styled.div`
  width: 50%;
  height: 300px;
  background: #f8f9f9;

  canvas {
    border: 3px solid #000;
  }

  @media (max-width: 768px) and (orientation: portrait) {
    width: 100%;
  }

  @media (max-width: 768px) and (orientation: landscape) {
    width: 90%;
    max-height: 200px;
  }
`

export const Footer = styled.footer`
  display: flex;
  margin-top: 10px;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`

export const Image = styled.img`
  width: 40px;
  margin-top: 10px;
  animation: ${rotation} 1.5s linear infinite alternate;
`
